<template>
  <div class="progressHandOver flexcenter">
    <transition>
      <div class="handOver flexcenter">
        <!-- 閉じる -->
        <div class="modal-close" v-on:click="$emit('close')"></div>

        <div class="lbold font20 modal-title">{{ message }}</div>
        <button class="reset" type=button v-on:click="clickButton(false)">
          <span class="font17 lbold">いいえ</span>
          <span v-if="!isMilestone" class="font13 block">(リセットしてやり直す)</span>
          <span v-if="isMilestone" class="font13 block">(ホーム画面に戻る)</span>
          <!-- レイアウトを合わせるため追加 -->
          <span v-if="isMilestone" class="font13 block" style="visibility:hidden;">ホーム画面に戻る</span>
        </button>
        <button class="yes" type=button v-on:click="clickButton(true)">
          <span class="font17 lbold">はい</span>
          <span v-if="!isMilestone" class="font13 block">(現在の進捗を引き継ぐ)</span>
          <span v-if="isMilestone" class="font13 block">(スコアをリセットして</span>
          <span v-if="isMilestone" class="font13 block">もう一度最初から始める)</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'

const MESSAGE = 'このアクティビティに現在の進捗度を引き継ぎますか？';
const MESSAGE_MILESTONE = 'スコアをリセットしてこのアクティビティをもう一度最初から始めますか？';

export default {
  name: 'progressHandOver',
  mixins: [
    common,
  ],
  props: {
    isMilestone: Boolean
  },
  data: function() {
    return {
      message: MESSAGE
    }
  },
  methods: {
    clickButton: function(flag) {
      this.$emit('clickButton', flag)
    }
  },
  mounted: function() {
    this.log("ProgressHandOver start mounted")
    this.setBodyStylePosition(true)

    // マイルストーンの場合
    if(this.isMilestone) {
      this.message = MESSAGE_MILESTONE;
    }
   },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// ProgressHandOver.vue?e3d8ffe4